module.exports = __webpack_public_path__ + "static/media/canciones.15fc5f18.jpg";